import type { Metadata } from "@/lib/head";

import CustomerScreenShell from "@/components/customer-screen-shell";
import Notice from "@buildpy/ui/notice";

// 404 는 HTML 이 이 메타로 그려진다(Next 15.0) — 없으면 제목이 루트 기본값 「빌드파이」 로 나가 하이드레이션 뒤에야 바뀐다.
export const metadata: Metadata = { title: "상담 접수" };

// 없는 접수 주소 — 고객이 보는 화면이라 영문 404 대신 /s/portfolio 와 같은 안내.
const NotFound = () => (
  <CustomerScreenShell centered>
    <Notice body="주소가 잘못되었거나 더 이상 접수를 받지 않는 창구입니다. 시공사에 받은 주소를 다시 확인해 주세요." title="상담 접수 창구를 찾을 수 없습니다" />
  </CustomerScreenShell>
);

export default NotFound;
